const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const createPqrsf = async (data) => {
  const response = await fetch(`${API_URL}/pqrsf/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Error al crear el registro PQRSF');
  }
  return response.json();
};

export const fetchPqrsf = async ({ query = {}, page = 1, limit = 50, sort } = {}) => {
  const body = { query, page, limit };
  if (sort) body.sort = sort;
  const response = await fetch(`${API_URL}/pqrsf/filter`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error('Error al obtener registros PQRSF');
  const result = await response.json();
  return {
    data: result.data || [],
    totalRecords: result.totalRecords || 0,
    totalPages: result.totalPages || 0,
    currentPage: result.currentPage || page,
  };
};

export const fetchPqrsfById = async (id) => {
  const response = await fetch(`${API_URL}/pqrsf/${id}`);
  if (!response.ok) throw new Error('Error al obtener el registro PQRSF');
  return response.json();
};

export const updatePqrsfEstado = async (id, estado, observaciones_internas) => {
  const response = await fetch(`${API_URL}/pqrsf/${id}/estado`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ estado, observaciones_internas }),
  });
  if (!response.ok) throw new Error('Error al actualizar estado PQRSF');
  return response.json();
};
